import { HelioCheckout } from "@heliofi/checkout-react";
import { toast } from "sonner";

interface HelioCheckoutWidgetProps {
  onPaymentComplete?: () => void;
}

export function HelioCheckoutWidget({ onPaymentComplete }: HelioCheckoutWidgetProps) {
  const config = {
    paylinkId: "695aa709c29f2b07d4963d27",
    theme: {
      themeMode: "dark" as const,
    },
    primaryColor: "#7ED957",
    neutralColor: "#000000",
    display: "inline" as const,
    onSuccess: () => {
      console.log("Payment completed - webhook will process entitlement");
      toast.success("Payment submitted! Click 'Refresh Status' to check your Pro access.");
      onPaymentComplete?.();
    },
    onError: (event: { transaction?: string; errorMessage?: string }) => {
      console.error("Payment error:", event);
      toast.error(event.errorMessage || "Payment failed. Please try again.");
    },
    onCancel: () => {
      console.log("Payment cancelled");
      toast.info("Payment cancelled");
    },
    onPending: () => {
      console.log("Payment pending");
      toast.info("Payment is being processed...");
    },
    onStartPayment: () => {
      console.log("Payment started");
    },
  };

  return (
    <div className="w-full min-h-[400px]">
      <HelioCheckout config={config} />
    </div>
  );
}
